(function () {
  'use strict';

  angular
    .module('directive.tab-equal-heights', [])

    /* @ngInject */
    .directive('tabEqualHeights', ["$timeout", function ($timeout) {
      return {
        link: function (scope, element) {
          $timeout(function () {
            var $tabs = element.children('.tab-pane');
            $tabs.show().children('.content').equalHeights().end().removeAttr('style');
          });
        }
      };
    }]);

})();
